import { render } from "./FieldSelect2.vue?vue&type=template&id=06c7b2ce"
import script from "./FieldSelect2.vue?vue&type=script&lang=js"
export * from "./FieldSelect2.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__